<template>
  <div v-if="dispersion" class="tutor-reviews-scores">
    <div v-if="items" class="tutor-reviews-scores__title">
      <span :class="`text-${color}`">{{ items.score }}</span>
      <BaseRatingStar
        :color="color"
        :star="items.score"
        size="md"
        class="mx-auto mt-2"
      />
      <span class="mt-6">
        ( {{ items.total }}
        {{ $t('titles.reviews') }} )
      </span>
    </div>
    <div v-if="dispersion && !hiddenStars" class="tutor-reviews-scores__values">
      <BaseProgressBar
        v-for="(item,key, index) in dispersion"
        :key="key"
        :text-before="Object.keys(dispersion).length - index"
        :text-after="`(${item})`"
        :max="totalScores"
        :score="item"
      />
    </div>
  </div>
</template>

<script>
import BaseRatingStar from '@design-system/base/rating/rating-star.vue'
import BaseProgressBar from '@design-system/base/progress/progress-bar'
export default {
  name: 'CommonTeacherReviewScores',
  components: {
    BaseProgressBar,
    BaseRatingStar
  },
  props: {
    items: {
      type: Object,
      default: () => {
      }
    },
    hiddenStars: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    dispersion () {
      return this.items?.dispersion ? this.ReverseObject(this.items?.dispersion) : {}
    },
    totalScores () {
      let out = 0
      for (const i in this.dispersion) {
        out += Number(this.dispersion[i])
      }
      return out
    }
  },
  methods: {
    ReverseObject (obj) {
      const newObj = {}
      const keys = Object.keys(obj).reverse()
      for (let i = 0; i < keys.length; i++) {
        newObj[keys[i] + ' stars'] = obj[keys[i]]
      }
      return newObj
    }
  }
}
</script>

<style scoped lang="scss">
.tutor-reviews-scores {
  @apply lg:flex lg:justify-between mt-8;
  &__title {
    @apply w-full lg:w-1/4 mr-16 flex flex-col content-center text-center;
    > span:first-of-type {
      @apply text__headline-1-md--bold lg:text__headline-2-md--bold;
    }
    > span:nth-of-type(2) {
      @apply text__body-3-md--bold;
    }
    > span:nth-of-type(3) {
      @apply text__headline-4-xs--regular text-label-text;
    }
  }
  &__values {
    @apply w-full lg:w-3/4 lg:flex-1 space-y-3 mt-8 lg:mt-0;
  }
}
</style>
